import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface FiltriOrtaggiProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedType: string;
  onTypeChange: (value: string) => void;
  selectedMonth: number;
  onMonthChange: (value: number) => void;
  selectedMoonPhase: string;
  onMoonPhaseChange: (value: string) => void;
  selectedDifficulty: string;
  onDifficultyChange: (value: string) => void;
}

const MESI = [
  "Tutti", "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

const FiltriOrtaggi = ({
  searchTerm,
  onSearchChange,
  selectedType,
  onTypeChange,
  selectedMonth,
  onMonthChange,
  selectedMoonPhase,
  onMoonPhaseChange,
  selectedDifficulty,
  onDifficultyChange
}: FiltriOrtaggiProps) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-lg space-y-4">
      <h3 className="text-lg font-semibold text-foreground mb-4">Filtra ortaggi</h3>

      {/* Ricerca */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Cerca ortaggio..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>

      {/* Filtri */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {/* Tipo */}
        <Select value={selectedType} onValueChange={onTypeChange}>
          <SelectTrigger>
            <SelectValue placeholder="Tipo ortaggio" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="tutti">Tutti i tipi</SelectItem>
            <SelectItem value="da frutto">Da frutto</SelectItem>
            <SelectItem value="da foglia">Da foglia</SelectItem>
            <SelectItem value="da radice">Da radice/bulbo</SelectItem>
            <SelectItem value="legumi">Legumi</SelectItem>
            <SelectItem value="aromatiche">Aromatiche</SelectItem>
          </SelectContent>
        </Select>

        {/* Mese */}
        <Select value={selectedMonth.toString()} onValueChange={(v) => onMonthChange(parseInt(v))}>
          <SelectTrigger>
            <SelectValue placeholder="Mese di semina" />
          </SelectTrigger>
          <SelectContent>
            {MESI.map((mese, index) => (
              <SelectItem key={index} value={index.toString()}>
                {mese}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Fase Lunare */}
        <Select value={selectedMoonPhase} onValueChange={onMoonPhaseChange}>
          <SelectTrigger>
            <SelectValue placeholder="Fase lunare" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="tutte">Tutte le fasi</SelectItem>
            <SelectItem value="crescente">🌓 Luna Crescente</SelectItem>
            <SelectItem value="calante">🌗 Luna Calante</SelectItem>
          </SelectContent>
        </Select>

        {/* Difficoltà */}
        <Select value={selectedDifficulty} onValueChange={onDifficultyChange}>
          <SelectTrigger>
            <SelectValue placeholder="Difficoltà" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="tutte">Tutte</SelectItem>
            <SelectItem value="facile">Facile</SelectItem>
            <SelectItem value="media">Media</SelectItem>
            <SelectItem value="difficile">Difficile</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default FiltriOrtaggi;
